"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AppHomeCarouselBannerPreviewer;
const react_1 = __importStar(require("react"));
const AppHomeCarouselBannerPreviewer_module_scss_1 = __importDefault(require("./AppHomeCarouselBannerPreviewer.module.scss"));
function AppHomeCarouselBannerPreviewer({ title, description, mobileImage, tabletImage, accessibilityText, }) {
    const [device, setDevice] = (0, react_1.useState)("phone");
    const [theme, setTheme] = (0, react_1.useState)("light");
    const containerClassName = `${AppHomeCarouselBannerPreviewer_module_scss_1.default[device]} ${AppHomeCarouselBannerPreviewer_module_scss_1.default[theme]}`;
    const titleClassNames = `${AppHomeCarouselBannerPreviewer_module_scss_1.default.title} ${AppHomeCarouselBannerPreviewer_module_scss_1.default[theme]}`;
    const descriptionClassNames = `${AppHomeCarouselBannerPreviewer_module_scss_1.default.description} ${AppHomeCarouselBannerPreviewer_module_scss_1.default[theme]}`;
    return (react_1.default.createElement("div", { className: AppHomeCarouselBannerPreviewer_module_scss_1.default.previewerContainer, "data-testid": "app-home-carousel-banner-previewer" },
        react_1.default.createElement("div", { className: AppHomeCarouselBannerPreviewer_module_scss_1.default.optionsContainer },
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", { htmlFor: "device-type" }, "Device type: "),
                react_1.default.createElement("select", { id: "device-type", defaultValue: "phone", onChange: (e) => setDevice(e.target.value) },
                    react_1.default.createElement("option", { value: "tablet" }, "Tablet"),
                    react_1.default.createElement("option", { value: "phone" }, "Phone"))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", { htmlFor: "device-theme" }, "System theme: "),
                react_1.default.createElement("select", { id: "device-theme", defaultValue: "light", onChange: (e) => setTheme(e.target.value) },
                    react_1.default.createElement("option", { value: "light" }, "Light"),
                    react_1.default.createElement("option", { value: "dark" }, "Dark")))),
        react_1.default.createElement("div", { className: containerClassName, "data-testid": "app-home-carousel-banner-container" },
            react_1.default.createElement("img", { alt: accessibilityText, className: AppHomeCarouselBannerPreviewer_module_scss_1.default.bannerImage, "data-testid": "app-home-carousel-banner-image", src: device === "phone" ? mobileImage : tabletImage }),
            react_1.default.createElement("div", { className: AppHomeCarouselBannerPreviewer_module_scss_1.default.textContent },
                react_1.default.createElement("p", { className: titleClassNames, "data-testid": "app-home-carousel-banner-title" }, title === null || title === void 0 ? void 0 : title.substring(0, 26)),
                react_1.default.createElement("p", { className: descriptionClassNames, "data-testid": "app-home-carousel-banner-description" }, description === null || description === void 0 ? void 0 : description.substring(0, 32))))));
}
